"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackbarProvider = void 0;
const react_1 = __importDefault(require("react"));
const snackbar_context_1 = require("./snackbar-context");
const snackbar_hook_1 = require("./snackbar-hook");
const snackbar_component_1 = require("./snackbar-component");
/**
 * Main component for snackbar providing context and rendering children + snackbar.
 */
function SnackbarProvider({ children, timeout, }) {
    const { context, ref } = snackbar_hook_1.useSnackbar();
    return (react_1.default.createElement(snackbar_context_1.SnackbarContext.Provider, { value: context },
        children,
        react_1.default.createElement(snackbar_component_1.SnackbarComponent, { ref: ref, timeout: timeout })));
}
exports.SnackbarProvider = SnackbarProvider;
//# sourceMappingURL=snackbar-provider.js.map